import * as StaticActions from "../actions/StaticActions";
import {connect} from "react-redux";
import React from "react";
import {Button, Card, Header, Icon, Image, Label, Loader, Modal, Segment, Table} from "semantic-ui-react";
import moment from "moment/moment";

class RouteInfoModal extends React.Component {

    state = {
        editorState: null,
    };


    render() {
        const {routes, shipsById, activeRouteLegs, showLineDetails} = this.props;

        let route = null;
        let ship = null;
        if (this.props.activeRouteId && routes) {
            let filteredRoutes = routes.filter(r => r.id === this.props.activeRouteId);
            if (filteredRoutes.length > 0) {
                route = filteredRoutes[0];
                ship = route.ship && shipsById[route.ship];
            }
        }

        // console.log(route, ship);


        //
        return <div
            style={{display: (route && this.props.open) ? "block" : "none"}}
                     // onClose={this.props.onClose}
                     className="route-info-modal-container"
            // centered={false}
            // closeIcon={true}
        >
            {route && ship && ship.name + " :" &&
            <Header className="header">
                {route.departure.city} to {route.arrival.city}
                <Button basic icon="close" onClick={() => this.props.onClose()} style={{float: "right"}} size="tiny" />
            </Header>
            }
            {route &&
            <div className="route-info-modal">

                <div className="top-part departure">
                    {!route.request && <h2>{route.departure.country}</h2>}
                    {!route.request && <h3>{moment(route.departure.date).format("D MMMM Y")}</h3>}
                    <h4>{route.departure.city}</h4>
                </div>

                <div className="top-part arrival">
                    {!route.request && <h2>{route.arrival.country}</h2>}
                    {!route.request && <h3>{moment(route.arrival.date).format("D MMMM Y")}</h3>}
                    <h4>{route.arrival.city}</h4>
                </div>

                <br style={{clear: "both"}}/>

                {route.request ? <div>
                    <Label>Requested route</Label><br/><br/>
                    Requested {route.requests.length} time{route.requests.length === 1 ? "" : "s"}.<br/><br/>
                    {/*<Button color="blue" size="mini">*/}
                    {/*Request*/}
                    {/*</Button>*/}
                </div> : <div>
                    <Label basic size={"small"}><Icon
                        name="clock"/>{route.duration} days</Label>
                    {/*{ship && <Label basic size="small">{ship.company}</Label>}*/}
                    {route.cost &&
                    <Label basic size="small">€ {route.cost}</Label>}
                </div>
                }

                <br style={{clear: "both"}}/>

                {ship && <div className="ship-info">
                    {/*<div className="ship-photos">*/}
                    {/*{ship.photos && ship.photos.map((photo, i) => <img src={photo} key={ship.id + "photo" + i}/>)}*/}
                    {/*</div>*/}
                    <Segment>
                        {ship.photos && <Image floated='left' src={ship.photos[0]} key={ship.id + "photo"}
                                               alt={ship.name + ", source: " + ship.photoSourceUrl}/>}
                        <strong>{ship.name}</strong><br/>
                        {ship.introduction}<br/><br/>
                        {route.passengers && <Label basic size="small"><Icon name="people"/> {route.passengers}</Label>}
                        <br style={{clear: "both"}}/>
                    </Segment>
                    <br/>

                    <Button as="a" href={ship.homepageUrl} target="_blank"
                            content='Book' icon='external' labelPosition='right'
                            rel="noopener noreferrer"/>

                </div>}

                <br/><br/>

                {activeRouteLegs && <div>
                    <h2>Other legs</h2>
                    <Table compact>
                        <Table.Body>
                            {activeRouteLegs.map(legRoute => <Table.Row active={legRoute.id === route.id}
                                                                        onClick={() => showLineDetails(legRoute.id)}
                                                                        className="clickable">
                                <Table.Cell>
                                    {legRoute.departure.country},&nbsp;
                                    {legRoute.departure.city}
                                </Table.Cell>
                                <Table.Cell>
                                    {moment(legRoute.departure.date).format("D MMMM Y")}
                                </Table.Cell>
                                <Table.Cell>
                                    {legRoute.arrival.country},&nbsp;
                                    {legRoute.arrival.city}
                                </Table.Cell>
                                <Table.Cell>
                                    {moment(legRoute.arrival.date).format("D MMMM Y")}
                                </Table.Cell>
                            </Table.Row>)}
                        </Table.Body>
                    </Table>
                </div>}

            </div>
            }
        </div>
    }
}

export default connect(state => ({
    routes: state.interactiveMap.routes,
    shipsById: state.interactiveMap.shipsById,
}), dispatch => ({}))(RouteInfoModal)


// WEBPACK FOOTER //
// ./src/components/RouteInfoModal.js